import { Component, Input, SimpleChanges } from "@angular/core";

@Component({
  selector: "app-oklahoma-state-form",
  standalone: true,
  imports: [],
  templateUrl: "./oklahoma-state-form.component.html",
  styleUrl: "./oklahoma-state-form.component.scss",
})
export class OklahomaStateFormComponent {
  @Input() policyDetails!: any;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes["policyDetails"]) {
      this.policyDetails = changes["policyDetails"].currentValue?.aul_013_24;
    }
  }
}
